module.exports = __webpack_public_path__ + "img/testimonial-nina-glavac.c0614573.png";